import { useEffect, useState } from 'react';
import { automaticDiscount, type AutomaticSaving, type CodeCart } from '../api/discountCode';

// Prices the store's best automatic discount for the cart whenever it changes, when the store runs any; a failed
// read shows no automatic saving rather than one the order might not give.
export function useAutomaticDiscount(cart: CodeCart | null, enabled: boolean): AutomaticSaving | null {
  const [saving, setSaving] = useState<AutomaticSaving | null>(null);
  const cartKey = cart ? JSON.stringify(cart) : '';
  useEffect(() => {
    if (!enabled || !cartKey) return void setSaving(null);
    let live = true;
    automaticDiscount(JSON.parse(cartKey) as CodeCart).then((next) => { if (live) setSaving(next); }).catch(() => { if (live) setSaving(null); });
    return () => { live = false; };
  }, [enabled, cartKey]);
  return saving;
}
